import React, { useEffect, useState } from "react";
import { Tabs, Dropdown, Table, Pagination, Input, Button,Loading } from "@jdcfe/legao";
import { DatePicker } from 'antd';
import moment from 'moment';
import { observer } from "mobx-react-lite";
import { queryAuthPackList } from "utils/api";
import useStore from "stores";
import qs from "qs";
import dateFormat from 'dateformat';
import NoPermission from "./../NoPermission";
import 'antd/dist/antd.css';
import "./style.scss";
const { RangePicker } = DatePicker;
const tableColumn = [
  {
    title: "创建时间",
    dataIndex: "createtime",
    key: "1",
    width: 150,
  },
  {
    title: "消息ID",
    dataIndex: "normalType",
    key: "2",
    width: 120,
  },
  {
    title: "消息类型",
    dataIndex: "type",
    key: "3",
    width: 120,
  },
  {
    title: "消息内容",
    dataIndex: "body",
    key: "4",
    width: 180,
  },
  {
    title: "消息时间",
    dataIndex: "time",
    key: "5",
    width: 180,
  },
  {
    title: "消息状态",
    dataIndex: "status",
    key: "6",
    width: 80,
  }
];

const LogMonitorContent = observer(() => {
  const pageSize = 20;
  const [empty, setEmpty] = useState(null);
  const startTime = dateFormat(new Date().getTime() - 24 * 60 * 60 * 1000 * 2, "yyyy-mm-dd hh:MM:ss");
  const endTime = dateFormat(new Date().getTime(), "yyyy-mm-dd hh:MM:ss");
  const [defaultCurrent, setDefaultCurrent] = useState(1);
  const [createdStartTime, setCreatedStartTime] = useState(startTime);
  const [createdEndTime, setCreatedEndTime] = useState(endTime);
  const [dates, setDates] = useState([moment(startTime), moment(endTime)]);
  const [hackValue, setHackValue] = useState();
  const [value, setValue] = useState();
  const [normalType, setNormalType] = useState(1);
  const [processState, setProcessState] = useState('');
  const [contentKeyword, setContentKeyword] = useState('');
  const [messageId, setMessageId] = useState(null);
  const { logMonitorStore, subscriptionStore } = useStore();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  useEffect(() => {
    if (empty == null) {
      queryAuthPackList({
        appKey: query.appKey,
        openStateType: null,
      }).then((res) => {
        setEmpty(!res.data.result);
      });
    }

    if (!empty) {
      //消息类型
      subscriptionStore.queryClientMsgInfoList({
        appKey: query.appKey,
        pageIndex: 1,
        pageSize: 200,
        openState: 1
      });
    }

    if(subscriptionStore.list.clientMsgInfoList) {
      setNormalType(subscriptionStore.list.clientMsgInfoList[0].msgType);
      logMonitorStore.searchNormalMsgByOpenPortal({
        appKey: query.appKey,
        pageIndex: 1,
        pageSize,
        createdStartTime,
        createdEndTime,
        normalType: subscriptionStore.list.clientMsgInfoList[0].msgType
      });
    }
  }, [empty]);
  /*eslint-disable*/
  const handleChange = (index) => {};

  const handleMsgClick = (args) => {
    setNormalType(args[0].value);
  };

  const handleStatusClick = (args) => {
    setProcessState(+args[0].value === 0 ? null : +args[0].value);
  }

  const handleDateChange = (dates, dateStrings) => {
    setValue(dates);
    setCreatedStartTime(dateStrings[0]);
    setCreatedEndTime(dateStrings[1]);
  }

  const handleInputKeys = (e) => {
    setContentKeyword(e.target.value);
  }

  const handleInputId = (e) => {
    setMessageId(e.target.value);
  }

  const disabledDate = current => {
    if (!dates || dates.length === 0) {
      return current < moment().subtract('days', 16);
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') > 2;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > 2;
    return current < moment().subtract('days', 16) || tooEarly || tooLate;
  }

  const onOpenChange = open => {
    // if (open) {
    //   setHackValue([]);
    //   setDates([]);
    // } else {
    //   setHackValue(undefined);
    // }
  };

  const handleSearch = (e) => {
    setDefaultCurrent(1);
    let data = {
      appKey: query.appKey,
      pageIndex: 1,
      pageSize,
      createdStartTime,
      createdEndTime,
      messageId
    };
    processState && (data['processState'] = processState);
    contentKeyword && (data['contentKeyword'] = contentKeyword);
    normalType && (data['normalType'] = normalType);
    logMonitorStore.searchNormalMsgByOpenPortal(data);
  }

  const handleReset = (e) => {
    location.reload();
  }

  const handlePage = (index, size) => {
    setDefaultCurrent(index === 0 ? 1 : index);
    let data = {
      appKey: query.appKey,
      pageIndex: index,
      pageSize,
      createdStartTime,
      createdEndTime,
      normalType,
      messageId
    };
    processState && (data['processState'] = processState);
    contentKeyword && (data['contentKeyword'] = contentKeyword);

    logMonitorStore.searchNormalMsgByOpenPortal(data);
  };

  return (
    <div className="subscribe_content">
      {empty != null ? (
        (
          empty ? (
            <div className="no_subscribe">
              <NoPermission content="应用未绑定合同，无法查看日志监控" isshow={false}/>
            </div>
          ): 
          <Tabs
            className="tabs-wrapper"
            type="line"
            onChange={(i) => {
              handleChange(i);
            }}
          >
            <Tabs.Panel label="消息日志">
              <div className="search-wrapper">
                <div className="search-item">
                  <label>消息关键词</label>
                  <Input
                    placeholder="请输入消息关键词"
                    value={contentKeyword}
                    maxLength={100}
                    onChange={(e) => handleInputKeys(e)}
                    style={{width: '400px'}}
                  />
                </div>
                <div className="search-item">
                  <label>消息类型</label>
                  <Dropdown
                    className={`subscribe_dropdown msg_dropdown`}
                    trigger="click"
                    updateButtonText={true}
                    defaultIndex={normalType}
                    buttonText={subscriptionStore.list.clientMsgInfoList && subscriptionStore.list.clientMsgInfoList[0].msgName}
                    hideOnClick={true}
                    onItemSelect={(...args) => {
                      handleMsgClick(args);
                    }}
                  >
                    {subscriptionStore.list.clientMsgInfoList &&
                      subscriptionStore.list.clientMsgInfoList.map(
                        (item, index) => (
                          <Dropdown.Item value={item.msgType} key={index}>
                            {item.msgName}
                          </Dropdown.Item>
                        )
                    )}
                    </Dropdown>
                </div>
                <div className="search-item">
                  <label>消息ID</label>
                  <Input
                    placeholder="请输入消息ID"
                    value={messageId}
                    maxLength={100}
                    onChange={(e) => handleInputId(e)}
                    style={{width: '260px'}}
                  />
                </div>
                <div className="search-item">
                  <label>消息状态</label>
                  <Dropdown
                    className={`subscribe_dropdown`}
                    trigger="click"
                    updateButtonText={true}
                    buttonText="请选择"
                    hideOnClick={true}
                    onItemSelect={(...args) => {
                      handleStatusClick(args);
                    }}
                  >
                    <Dropdown.Item value="">请选择</Dropdown.Item>
                    <Dropdown.Item value="1">待处理</Dropdown.Item>
                    <Dropdown.Item value="2">已处理</Dropdown.Item>
                  </Dropdown>
                </div>
                <div className="search-item">
                  <label>创建时间&nbsp;&nbsp;&nbsp;&nbsp;</label>
                  <RangePicker
                  showTime={true}
                  allowClear={false}
                  inputReadOnly={true}
                  placeholder={['请选择开始日期', '请选择结束日期']}
                  allowEmpty={[false, false]}
                  value={hackValue || value}
                  defaultValue={dates}
                  disabledDate={disabledDate}
                  onCalendarChange={val => setDates(val)}
                  onChange={(val,valString) => {handleDateChange(val,valString)}}
                  onOpenChange={onOpenChange}
                  />
                </div>
                <div className="search-item">
                  <Button styleType="primary" onClick={() => handleSearch()} clstag="pageclick|keycount|VopOpenConsole_1611892618710|16"> 
                    <span className={`lg-btn-text`}>查询</span>
                  </Button>
                </div>
                <div className="search-item">
                  <Button styleType="minor" onClick={() => handleReset()} clstag="pageclick|keycount|VopOpenConsole_1611892618710|17">
                    <span className={`lg-btn-text`}>重置 </span>
                  </Button>
                </div>
              </div>
              
              <div className="subscribe-table">
              {logMonitorStore.isLoading && (<div className="logmonitor-mask-loading"><Loading/></div>)}
                <Table
                  columns={tableColumn}
                  data={logMonitorStore.tableData}
                  emptyText={`${logMonitorStore.isLoading?'':'已选条件下暂无数据，请更换筛选条件'}`}
                />
              </div>
              <div className="subscribe_page">
                <Pagination
                  className="per_page"
                  total={logMonitorStore.total}
                  pageSize={pageSize}
                  viewSize={5}
                  hasChangeSize={false}
                  defaultCurrent={defaultCurrent}
                  hasJump={false}
                  hasTotal={true}
                  onChange={(index, size) => handlePage(index, size)}
                />
              </div>
            </Tabs.Panel>
          </Tabs>
        )
      ): ''}
    </div>
  );
});

export default LogMonitorContent;
